import { Box, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import PageHeader from "../../../../../../../components/PageHeader";
import { usePlantContext } from "../../../../../../../components/Drawers/TreeViewDrawer/PlantContext";

export default function MRVPage() {
  const { mrvId } = useParams();
  const { plant } = usePlantContext();

  return (
    <Box>
      <PageHeader plant={plant} pageTitle="Material Receipt Voucher (MRV)" />
      <Box sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          {mrvId ? `MRV #${mrvId}` : "Coming soon..."}
        </Typography>
      </Box>
    </Box>
  );
}
